import React from 'react';
import s from './styles.module.css'
import classNames from "classnames";
import {Tooltip} from "@mui/material";

const TableElement = ({
                          showTooltip = false,
                          children,
                          disabled = false,
                          onClick,
                          left,
                          right,
                          className,
                          width,
                      }) => {

    return (
        <>
            <Tooltip title={showTooltip ? children : null}>
                <div onClick={() => (onClick && disabled === false) && onClick()}

                     className={classNames(s.item, className, disabled && s.disabled)}
                     style={{
                         minWidth: width,
                         maxWidth: width,
                         width,
                         marginLeft: left,
                         marginRight: right,
                     }}>
                    {children}
                </div>
            </Tooltip>
        </>

    );
};

export default TableElement;
